import wcs from './index'
import axios from 'axios'

export const getCMSPlacements = async (parameters, name) => {
  const domain = wcs.getEnvConfig('currentDomain') || ''
  const { locale, storeId, langId, catalogId } = wcs.getStoreConfig()
  const userClusterValue = window.algoliaConfig.isEarlyAccessParam ? 'EarlyAccess' : 'None'
  
  const urlParams = new URLSearchParams(window.location.search)
  const userVariant = urlParams.get('userVariant')
  const previewDate = urlParams.get('previewDate')

  const queryParams = new URLSearchParams({
    exposeError: 'false',
    storeId,
    langId,
    catalogId,
    locale
  })
  
  // check if the parameters are empty
  if (parameters?.name) queryParams.set('var', parameters.name)
  if (parameters?.placement) queryParams.set('placement', parameters.placement)
  if (parameters?.view) queryParams.set('view', parameters.view)
  if (parameters?.pageId) queryParams.set('pageId', parameters.pageId)
  if (parameters?.categoryId) queryParams.set('categoryId', parameters.categoryId)
  if (parameters?.productId) queryParams.set('productId', parameters.productId)
  if (userVariant) queryParams.set('userVariant', userVariant)
  if (previewDate) queryParams.set('previewDate', previewDate)

  const parameterObj = {
    USER_CLUSTER: userClusterValue,
  }
  
  if (parameters?.upc) parameterObj.upc = parameters.upc
  if (parameters?.categories) parameterObj.categories = parameters.categories
  
  queryParams.set('parameter', JSON.stringify(parameterObj))

  const url = `${domain}/wcs/resources/store/${storeId}/cms/include?${queryParams.toString()}`

  try {
    const response = await axios.get(url, {
      headers: parameters?.headers || null,
      data: parameters?.axiosDataType || null,
    })
    
    return response.data
  } catch (error) {
    console.error(
      'Error in getCMSPlacements :',
      error.response ? error.response.data : error.message
    )
    return 'Error'
  }
}
